import { type FC, useEffect } from 'react'
import classNames from 'classnames'
import { EnumIconButtonShape } from 'shared/ui/IconButton'
import { Dropdown, DropdownContent, layoutStore } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { PowerDialerEditorAction } from 'widgets/PowerDialer/ui/PowerDialerEditor'
import { CreateSmartViewActionDropdownItem } from 'widgets/SmartViewModal'
import { NewMessageActionDropdownItem } from 'pages/conversations/ui/ConversationHeaderListDropdown/ui/Actions/NewMessageDropdownItem'
import { MakeCallActionDropdownItem } from 'pages/conversations/ui/ConversationHeaderListDropdown/ui/Actions/MakeCallDropdownItem'
import { CreateContactActionDropdownItem } from 'pages/conversations/ui/ConversationHeaderListDropdown/ui/Actions/CreateContactActionDropdownItem'
import styles from './styles.module.scss'

type IConversationHeaderListDropdownProps = {
  disabled: boolean
  ariaLabel?: string
  onChangeCall?: () => void
  onChangeNew?: () => void
  onChangeContactCreate?: () => void
  onChangeSmartViewCreate: () => void
}

export const ConversationHeaderListDropdown: FC<IConversationHeaderListDropdownProps> = ({
  disabled,
  ariaLabel,
  onChangeCall,
  onChangeNew,
  onChangeContactCreate,
  onChangeSmartViewCreate,
}) => {
  const { conversationStore, featureFlagsStore, inboxesStore } = useEntitiesContext()
  const { isActionDisabled } = conversationStore
  const isPFTInbox = inboxesStore.currentInbox?.isPFTInbox

  const onEventHotKey = (e: KeyboardEvent) => {
    const osMac = navigator.userAgent.indexOf('Mac') !== -1
    const comboKey = osMac ? e.metaKey : e.ctrlKey

    if (comboKey) {
      if (e.code === 'KeyM') {
        if (isActionDisabled) return

        e.preventDefault()

        onChangeNew?.()
      }

      if (e.code === 'KeyC') {
        if (document.getSelection()?.toString().length) return
        if (isPFTInbox) return

        e.preventDefault()

        onChangeCall?.()
      }
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', onEventHotKey)

    return () => {
      window.removeEventListener('keydown', onEventHotKey)
    }
  }, [isActionDisabled, isPFTInbox])

  const { isMediumView } = layoutStore

  return (
    <Dropdown
      ariaLabel={ariaLabel || 'HeaderList'}
      icon={'add'}
      placement={'right-start'}
      disabled={disabled}
      iconButtonProps={{
        disabled: disabled,
        transparentBackground: disabled,
        fontSize: 20,
        shape: EnumIconButtonShape.Rounded,
        color: disabled ? 'transparent' : 'tertiary',
        ariaLabel: 'DropdownHeaderList_actionButton',
      }}
      sizeTriggerButton={'medium'}
      customComponent={(onCloseMenu) => (
        <DropdownContent
          className={classNames(styles.dropdownContent, {
            [styles.dropdownContentMobile]: isMediumView,
          })}
        >
          <NewMessageActionDropdownItem
            onClick={() => {
              onChangeNew?.()
              onCloseMenu()
            }}
          />
          <MakeCallActionDropdownItem
            onClick={() => {
              onChangeCall?.()
              onCloseMenu()
            }}
          />
          <PowerDialerEditorAction
            variant={'dropdownItem'}
            onClick={() => {
              onCloseMenu()
            }}
          />
          <CreateContactActionDropdownItem
            onClick={() => {
              onChangeContactCreate?.()
              onCloseMenu()
            }}
          />
          <CreateSmartViewActionDropdownItem
            onClick={() => {
              onChangeSmartViewCreate()
              onCloseMenu()
            }}
          />
        </DropdownContent>
      )}
      width={featureFlagsStore.smart_views ? 248 : undefined}
    />
  )
}
